import { Link } from "react-router-dom";
import { useProfile } from "../../../data/context/auth-context";
import style from "./style.module.scss";

interface AdminLinkProps {
  isInverted?: boolean;
  className?: string;
}

const AdminLink = ({ isInverted, className }: AdminLinkProps) => {
  const profile = useProfile();

  if (profile?.role !== "admin") {
    return null;
  }

  return (
    <Link
      to="/admin"
      className={`${style.link} ${isInverted ? style.inverted : ""} ${className || ""}`}
    >
      Admin
    </Link>
  );
};

export default AdminLink;
